import {ReactElement, ReactNode} from "react";

export interface SubTitleProps {
    children: ReactNode
}

export function SubTitle(props: SubTitleProps): ReactElement {
    return (
        <h2 className="text-lg font-barlow font-semibold leading-snug">
            {props.children}
        </h2>
    );
}